import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap"; // Importing React Bootstrap components
import ProgressBar from "react-bootstrap/ProgressBar";

// import Editbtn from '../images/circum_edit.svg';
// import viewbtn from '../images/iconoir_eye-solid.svg';
// import commentbtn from '../images/lets-icons_comment-light.svg';
// import stepbtn from "../pages/Skills/images/step_btn.svg";
import Select from "react-select";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

const ListAprraisal = () => {
  const [posts, setPosts] = useState({ appraisaldata: [] });
  const [editedSmartGoal, setEditedSmartGoal] = useState(null);
  const [selectedSmartGoal, setSelectedSmartGoal] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showViewModalsub, setShowViewModalsub] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [viewSmartGoal, setViewSmartGoal] = useState(null);
  const [viewSubGoal, setViewSubGoal] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [postsSub, setPostsSub] = useState({ subgoals: [] });
  const [editedSubGoal, setEditedSubGoal] = useState(null);
  const [options, setOptions] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [filterdepartment, setFilterdepartment] = useState(null);
  const [filterenddate, setFilterenddate] = useState(null);
  const [filterassignee, setFilterassignee] = useState(null);
  const [showEditModalsub, setShowEditModalsub] = useState(false);
  const [showsmartgoalEdit, setshowSmartGoaledit] = useState(false);
  const [showsubgoalEdit, setShowSubgoalEdit] = useState(false);
  const managerId = localStorage.getItem("employeeid");
  const [employeesData, setEmployeesData] = useState([]);
  const [setFieldvalue, setFieldValue] = useState([]);
  const [touched, setTouched] = useState([]);
  const [errors, setErrors] = useState([]);
  const [values, setValues] = useState([]);
  const [allemployees, setAllEmployees] = useState([]);
  const [showdatefilter, setShowDatefilter] = useState(false);
  const [showdeptfilter, setShowDeptfilter] = useState(false);
  const [showassigneefilter, setShowAssigneefilter] = useState(false);
  const [pastappraisals, setPastAppraisals] = useState(false);
  const [readonly, SetReadonly] = useState(0);

  const [assigneevalues, setAssigneevalues] = useState(null);
  const [isHR, setIsHR] = useState(false);
  let role = localStorage.getItem("userrole");
  let deptid = localStorage.getItem("departmentid");
  let currentuserid = localStorage.getItem("employeeid");
  const [period, setPeriod] = useState("");
  let searchString = "ROLE_";
  let rolename = "";
  const location = useLocation();
  let path = location.pathname;

  console.log(posts?.appraisaldata, "jjjjjj");

  const storedEmployeeId = localStorage.getItem("employeeid");

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const storedEmployeeId = localStorage.getItem("userid");

        let strAPI = `${baseURL}/getallAppraisalsforHRApproval?userid=${storedEmployeeId}&did=${deptid}`;

        // HR → get ALL appraisals
        if (
          role === "ROLE_HR" ||
          role === "ROLE_SENIOR HR MANAGER" ||
          role === "ROLE_SUPER ADMIN"
        ) {
          strAPI = `${baseURL}/getallAppraisalsforHRApproval?userid=${storedEmployeeId}`;
          setIsHR(true);

          setShowDatefilter(true);
          setShowDeptfilter(true);
          setShowAssigneefilter(true);
          setshowSmartGoaledit(true);
          setShowSubgoalEdit(true);
        }

        // Manager & Supervisor → only their team
        if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
          strAPI = `${baseURL}/getallAppraisalsforHRApproval?userid=${storedEmployeeId}&did=${deptid}`;

          setshowSmartGoaledit(false);
          setShowSubgoalEdit(true);

          setShowDatefilter(true);
          setShowDeptfilter(false);
          setShowAssigneefilter(true);
        }

        // Past Appraisal Page
        if (path === "/listpastappraisal") {
          strAPI = `${baseURL}/getPastAppraisals?did=${deptid}&assignee=${storedEmployeeId}`;

          setPastAppraisals(true);
          SetReadonly(1);
        } else {
          setPastAppraisals(false);
          SetReadonly(0);
        }

        const { data } = await axios(strAPI);

        setPosts({ appraisaldata: data.appraisaldata });

        // User role
        if (role === "ROLE_USER") {
          setshowSmartGoaledit(false);
          setShowSubgoalEdit(false);

          setShowDatefilter(false);
          setShowDeptfilter(false);
          setShowAssigneefilter(false);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPostList();
  }, []);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.appraisaldata.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define the getProgressColor function
  const getProgressColor = (progress) => {
    if (progress <= 30) {
      return "danger";
    } else if (progress <= 60) {
      return "warning";
    } else {
      return "success";
    }
  };

  // Toggle expand row
  const toggleExpand = (index, smartid) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const [value, setValue] = useState([]);

  const getAllSmartgoalsforConditions = async (did, enddate, assignee) => {
    try {
      const { data } = await axios(
        `${baseURL}/getallAppraisalsforHRApproval?did=` +
          did +
          "&assignee=" +
          assignee +
          "&enddate=" +
          enddate
      );
      //if (Array.isArray(data.smartgoals)) {
      setPosts([]);
      // let sm = JSON.parse(data.smartgoals);
      //alert(sm);
      setPosts({ appraisaldata: data.appraisaldata });
      //} else {
      console.error("Data is not an array:", data);
      //  }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + managerId
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);

        console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    //   alert(managerId);
    // if (managerId) {managerId
    fetchData();

    //}
  }, [managerId]);

  const handleChangeDepartment = (event) => {
    let did = event.target.value;
    setFilterdepartment(did);
    getAllSmartgoalsforConditions(did, filterenddate, filterassignee);
  };

  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const response = await axios.get(`${baseURL}/getallassigneesb`);
        setAllEmployees(response.data.employees);
        setEmployeesData(response.data.employees);
        setAssigneevalues(
          employeesData.map((employee) => employee.id).join(",")
        );
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
  }, []);

  const handleChangdDate = (event) => {
    let enddate = event.target.value;
    setFilterenddate(enddate);

    getAllSmartgoalsforConditions(filterdepartment, enddate, filterassignee);
  };
  const handleChangdAssignee = (event) => {
    let assignee = event.target.value;
    setFilterassignee(assignee);
    getAllSmartgoalsforConditions(filterdepartment, filterenddate, assignee);
  };

  const handleResetFilter = () => {
    setFilterdepartment("");
    setFilterenddate("");
    setFilterassignee("");
  };

  return (
    <div>
      {/* <div className='col-lg-12 d-flex flex-wrap p-2 pb-2'>
            
            { showdatefilter && (
                <div className='col-lg-3'>
                 
                    <input type="date" name="enddate" 
                    value={filterenddate}
                    className="w-75 p-1 ml-1"
                     onChange={(e) => {
                        handleChangdDate(e);
                       
                      }}
                    ></input>
                </div>
                )}
               
                
                 { showassigneefilter && (
                <div className='col-lg-3 d-flex'>
                   
                    <select  className="w-75 ml-1 p-0"  
                    value={filterassignee}
                    onChange={(e) => {
                        handleChangdAssignee(e);
                       
                      }}>
                        <option>Select Assignee</option>
                        
                        {teamMembers.map((option) => (
                      <option key={option.id} value={option.employeeid}>
                        {option.FirstName} {option.LastName} -{option.employeeid}
                      </option>
                    ))}
                     
                    </select>
                </div>
                  )}
                 
                 <input type="reset" value="Reset Filter" onClick={() => handleResetFilter()} />    
               
            </div> */}

      <h4>List {pastappraisals === true ? "of Past " : ""}Appraisals </h4>
      {/* Your DataTable rendering logic */}
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Employee Name</th>
            <th>Appraisal Date</th>
            <th>Grade</th>
            <th>Workflow</th>
            <th>Status</th>

            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts && currentPosts?.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                No data
              </td>
            </tr>
          ) : (
            ""
          )}
          {currentPosts?.map((appraisal, index) => (
            <React.Fragment key={index}>
              <tr>
                <td> {index + 1}</td>
                <td>{appraisal.FirstName}</td>
                <td>{formatDate(appraisal.appraisaldate)}</td>
                <td>{appraisal.grade}</td>
                <td>{appraisal.status}</td>
                <td className="p-1">
                  <span className={appraisal.status_style}>
                    {appraisal.finalappraisalstatus}{" "}
                  </span>
                </td>
                <td>
                  {isHR ? (
                    <a
                      className="bg-danger rounded pt-1 pb-1 pr-2 pl-2 text-white ml-2 text-decoration-none"
                      href={`/viewemployessappraisal?action=hr&id=${appraisal.employeeid}&r=${readonly}&aid=${appraisal.appraisal_id}&periods=${appraisal.period}`}
                    >
                      Review Appraisal
                    </a>
                  ) : (
                    <a
                      href={`/viewemployessappraisal?id=${appraisal.employeeid}&r=${readonly}&aid=${appraisal.appraisal_id}&periods=${appraisal.period}`}
                    >
                      View Appraisal
                    </a>
                  )}
                </td>

                {/* Action buttons */}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      {/* Edit Modal */}
      {showEditModal && editedSmartGoal && (
        <ReactBootstrap.Modal show={showEditModal}>
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit Smart Goal
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>
                <b>Title :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.title}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    title: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Description :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.description}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    description: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Start Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartGoal.startdate}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    startdate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>End Date :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="date"
                value={editedSmartGoal.enddate}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    enddate: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Progress :</b>
              </label>
              <input
                className="border-0 pl-2"
                type="text"
                value={editedSmartGoal.progress}
                onChange={(e) =>
                  setEditedSmartGoal({
                    ...editedSmartGoal,
                    progress: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>
                <b>Assigness</b>
              </label>

              <formik></formik>
              <Select
                isMulti={true}
                name="assignees2"
                options={employeesData.map((employee) => ({
                  value: employee.id,
                  label: `${employee.FirstName} ${employee.LastName}`,
                }))}
                value={employeesData.map((employee) => ({
                  value: employee.id,
                  label: `${employee.FirstName} ${employee.LastName}`,
                }))} // Select all options by default
                onChange={(selectedOption) => {
                  const selectedValues = selectedOption
                    ? selectedOption.map((option) => option.value)
                    : [];
                  setFieldValue("assignees", selectedValues);
                  setAssigneevalues(selectedValues);
                }}
              />

              {touched.assignees && errors.assignees ? (
                <div className="text-danger">{errors.assignees}</div>
              ) : null}
            </div>
            <input
              type="hidden"
              name="assignees"
              value={(values.assignees = assigneevalues)}
            />

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Comment Modal */}

      {/* Pagination */}

      <ReactBootstrap.Modal show={showViewModalsub}>
        {/* Content of the view modal */}
        {viewSubGoal && (
          <ReactBootstrap.Modal.Dialog className="w-100">
            <ReactBootstrap.Modal.Header closeButton>
              <ReactBootstrap.Modal.Title>
                Sub Goals Details
              </ReactBootstrap.Modal.Title>
            </ReactBootstrap.Modal.Header>
            <ReactBootstrap.Modal.Body>
              <p>
                <b>Title:</b> {viewSubGoal.title}
              </p>
              <p>
                <b>Description:</b> {viewSubGoal.description}
              </p>
              <p>
                <b>Start Date:</b> {viewSubGoal.startdate}
              </p>
              <p>
                <b>End Date:</b> {viewSubGoal.enddate}
              </p>
              <p>
                <b>Assignees:</b> {viewSubGoal.assignees}
              </p>
              <p>
                <b>Progress:</b> {viewSubGoal.progress}
              </p>
            </ReactBootstrap.Modal.Body>
            <ReactBootstrap.Modal.Footer>
              <ReactBootstrap.Button variant="secondary">
                Close
              </ReactBootstrap.Button>
              {/* Handle the logic for saving changes here if needed */}
            </ReactBootstrap.Modal.Footer>
          </ReactBootstrap.Modal.Dialog>
        )}
      </ReactBootstrap.Modal>

      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.appraisaldata.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default ListAprraisal;
